module.exports = __webpack_public_path__ + "static/mining-fad7833a748f1393549e827c669c667d.svg";